import '~/../node_modules/react-intl-tel-input/dist/main.css'
import './styles.scss'

import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import IntlTelInput from 'react-intl-tel-input'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

import countryCodeForPhone from 'lib/utils/country-code-for-phone'

const PREFERRED_PHONE_COUNTRIES = ['be', 'fr', 'ch']

const PhoneNumber = ({
  id,
  value,
  defaultCountry,
  onChange,
  onFlagSelect,
  checkPhoneNumber,
  style,
  onBlurTrigger = true
}) => {
  const [country, setCountry] = useState(countryCodeForPhone(value) || defaultCountry)

  const intlTelInputRef = useRef(null)

  const handlePhoneNumberChange = (_status, number, countryData) => {
    const parsedNumber = parsePhoneNumberFromString(number, countryData.iso2.toUpperCase())

    if (parsedNumber) {
      const formattedNumber = parsedNumber.formatInternational()

      setCountry(countryData.iso2)
      onChange(formattedNumber, parsedNumber.isValid(), countryData.iso2)

      if (checkPhoneNumber && parsedNumber.isValid()) {
        checkPhoneNumber()
      }
    } else {
      onChange(number, false, countryData.iso2)
    }
  }

  const preferredCountries = () => {
    return defaultCountry ? [defaultCountry] : PREFERRED_PHONE_COUNTRIES
  }

  const handleFlagSelect = (currentNumber, countryData) => {
    setCountry(countryData.iso2)
    if (onFlagSelect) {
      onFlagSelect(currentNumber, countryData)
    }
  }

  // Custom placeholder for Ivory Coast (CI)
  const getPlaceholder = countryCode => {
    if (countryCode === 'ci') {
      return '01 23 45 6789'
    }
    return undefined
  }

  return (
    <div className='intlTel-input'>
      <IntlTelInput
        fieldId={id}
        css={['intl-tel-input', 'input-text']}
        ref={intlTelInputRef}
        defaultValue={value}
        nationalMode
        autoHideDialCode
        onPhoneNumberChange={handlePhoneNumberChange}
        onPhoneNumberBlur={onBlurTrigger && !checkPhoneNumber ? handlePhoneNumberChange : null}
        onSelectFlag={handleFlagSelect}
        preferredCountries={preferredCountries()}
        style={style}
        placeholder={getPlaceholder(country)}
        format
      />
    </div>
  )
}

PhoneNumber.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  defaultCountry: PropTypes.string,
  onChange: PropTypes.func,
  onFlagSelect: PropTypes.func,
  checkPhoneNumber: PropTypes.func,
  style: PropTypes.object,
  onBlurTrigger: PropTypes.bool
}

export default PhoneNumber
